(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  // Hero-video: start gedempt in een lus, behalve onder prefers-reduced-motion (dan blijft
  // de poster staan). Geen pauzeknop (Rick, 26 sep): hij speelt altijd. Weigert de browser
  // autoplay (Safari in energiebesparing, Data Saver), dan start hij bij de eerste tik, klik
  // of toets van de koper — daarvoor mag de browser het wel.
  const video = document.querySelector('.hero-video');
  const verbinding = navigator.connection;
  const zuinig = verbinding && (verbinding.saveData || /2g|3g/.test(verbinding.effectiveType || ''));
  if (video && !zuinig && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const laad = () => {
      const desktop = video.dataset.bronDesktop && matchMedia('(min-width: 1025px)').matches;
      video.src = desktop ? video.dataset.bronDesktop : video.dataset.bron;
      video.play().catch(() => {
        const start = () => video.play().catch(() => {});
        for (const soort of ['pointerdown', 'keydown']) addEventListener(soort, start, { once: true });
      });
    };
    if (document.readyState === 'complete') laad();
    else addEventListener('load', laad, { once: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["werkplaats"] && !Shopify.designMode) return;
  try {
    
  // Afspeelicoon op de video-posts van de feed-app (Rick, 26 sep 2026): video speelt op tik
  // (mobiel) of hover (desktop), en zonder icoon ziet niemand dat een post een video is. Het
  // icoon staat rechtsboven en verdwijnt zolang de video speelt. De feed rendert pas na het
  // laden van de app, dus we kijken met een MutationObserver. Verandert de HTML van de app,
  // dan valt alleen het icoon weg; de feed zelf blijft werken.
  for (const apps of document.querySelectorAll('.werkplaats-apps')) {
    const sjabloon = apps.querySelector('.werkplaats-speel');
    if (!sjabloon) continue;
    const tegel = (video) => video.parentElement;
    const markeer = () => {
      for (const video of apps.querySelectorAll('video')) {
        const t = tegel(video);
        if (!t || t.querySelector(':scope > .feed-speel')) continue;
        const icoon = document.createElement('span');
        icoon.className = 'feed-speel';
        icoon.append(sjabloon.content.cloneNode(true));
        t.append(icoon);
        t.toggleAttribute('data-speelt', !video.paused);
      }
    };
    // play en pause bubbelen niet; in de capture-fase vangen we ze voor alle video's tegelijk.
    const volg = (e) => {
      if (e.target instanceof HTMLVideoElement) tegel(e.target)?.toggleAttribute('data-speelt', !e.target.paused);
    };
    apps.addEventListener('play', volg, true);
    apps.addEventListener('pause', volg, true);
    new MutationObserver(markeer).observe(apps, { childList: true, subtree: true });
    markeer();
  }

  } catch(e) { console.error(e); }
})();
})();
